var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 43,
    viewBox: "0 0 8.4667 11.377",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.036122 0 0 .035764 .52917 .52917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m74.523 221.94 61.592-0.10732v-40.475c0-10.979 6.0509-21.352 22.241-30.335 16.189-8.9792 61.385-27.201 61.385-75.108 0-47.91-47.461-80.839-87.357-87.825-39.889-6.986-83.11-2.3897-113.78 26.032-27.465 25.45-33.253 45.582-33.253 89.997h61.543v-10.323c0-23.667 3.2369-48.65 43.212-55.483 21.819-3.7297 42.272 2.0594 54.404 12.096 13.878 11.477 13.99 37.339-8.1239 50.216l-34.689 19.962c-20.234 10.979-27.173 23.202-27.173 41.166z",
    strokeWidth: 7.3613
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2188 0 0 1.1604 -165.32 -126.82)",
    strokeWidth: 6.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "m196.64 370.69v-51.005h50.212v51.005z",
    strokeWidth: 6.19
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion2);
export default __webpack_public_path__ + "static/media/question2.cb8ea80435ae2e126cc016d71bd52d6e.svg";
export { ForwardRef as ReactComponent };